import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-technology',
  templateUrl: './technology.component.html',
  styleUrls: ['./technology.component.scss']
})
export class TechnologyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.scroll();
  }

  scroll() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }


  services = [
    {
      title: 'Backend Engineering',
      subTitle: 'We use Java and JavaScript based frameworks for server-sidedevelopment. We use relational as well as NoSQL databases for faster processing of complex set of data. ',
      offers: [
     'Java', 'Node', '.Net Core', 'Python', 'Go'
      ],
      images: [
        '../../../assets/images/patch/technologiesLang/1.png',
        '../../../assets/images/patch/technologiesLang/2.png',
         '../../../assets/images/patch/technologiesLang/3.png',
         '../../../assets/images/patch/technologiesLang/4.png',
         '../../../assets/images/patch/technologiesLang/5.png',
      ]
    },
    {
      title: 'Frontend Engineering',
      subTitle: 'JavaScript in combination with HTML and CSS has revolutionised the way web and mobile applications are built and we are extremely adept at implementing the JS universe.. ',
      offers: [
     'Angular', 'React', 'Vue',
      ],
      images: [
        '../../../assets/images/patch/technologiesLang/6.png',
        '../../../assets/images/patch/technologiesLang/7.png',
        '../../../assets/images/patch/technologiesLang/8.png',
        '../../../assets/images/patch/technologiesLang/9.png',
        '../../../assets/images/patch/technologiesLang/10.png',
        '../../../assets/images/patch/technologiesLang/11.png', 
      ]
    },
    {
      title: 'Mobility',
      subTitle: 'Experts in developing experiential applications using native as well as hybrid technologies for mobile, tablets and connected devices.',
      offers: [
     'Android', 'IOS', 'Cross Platform'
      ],
      images: [
        '../../../assets/images/patch/technologiesLang/12.png',
        '../../../assets/images/patch/technologiesLang/13.png',
        '../../../assets/images/patch/technologiesLang/14.png',
        '../../../assets/images/patch/technologiesLang/15.png',
        '../../../assets/images/patch/technologiesLang/16.png',
        '../../../assets/images/patch/technologiesLang/17.png',
     
      ]
    },
    {
      title: 'Frameworks',
      subTitle: 'Frameworks to design & support development of Platform, Software & Web Applications with faster delivery & consistency. ',
      offers: [
     'OOP', 'AOP', 'JS  '
      ],
      images: [
        '../../../assets/images/patch/technologiesLang/18.png',
        '../../../assets/images/patch/technologiesLang/19.png',
        '../../../assets/images/patch/technologiesLang/20.png',   
     
      ]
    },
    {
      title: 'Cloud & DevOps',
      subTitle: 'We help customers migrate to Cloud and provide on-going DevOps automation & 24*7 incident management services.',
      offers: [
      'AWS', 'Azure', 'CI/CD'
      ],
      images: [
        '../../../assets/images/patch/technologiesLang/21.png',
        '../../../assets/images/patch/technologiesLang/22.png',
        '../../../assets/images/patch/technologiesLang/23.png', 
        '../../../assets/images/patch/technologiesLang/24.png',
        '../../../assets/images/patch/technologiesLang/25.png',
        '../../../assets/images/patch/technologiesLang/26.png',
        '../../../assets/images/patch/technologiesLang/27.png',
      ]
    },
    {
      title: 'Third party integrations',
      subTitle: 'We have expertise in integrating various 3rd party solutions be it different CRMs, SMS/Email generators or scheduling events in future.',
      offers: [
     'IOT', 'CRM', 'Sales Force', 'Service Cloud'
      ],
      images: [
        '../../../assets/images/patch/technologiesLang/28.png',
        '../../../assets/images/patch/technologiesLang/29.png',
        '../../../assets/images/patch/technologiesLang/30.png',
        '../../../assets/images/patch/technologiesLang/31.png',
        '../../../assets/images/patch/technologiesLang/32.png',
        '../../../assets/images/patch/technologiesLang/33.png',
        '../../../assets/images/patch/technologiesLang/34.png',
        '../../../assets/images/patch/technologiesLang/35.png',
        '../../../assets/images/patch/technologiesLang/36.png',
        '../../../assets/images/patch/technologiesLang/37.png',
        '../../../assets/images/patch/technologiesLang/38.png',
        
      ]
    },
    {
      title: 'Databases',
      subTitle: 'We help enterprises to access & manage data across different sources, seamlessly integrating on-premises and cloud environments to extract actionable insights.',
      offers: [
     'SQL', 'No SQL', 'Elastic Search', 'Cassandra'
      ],
      images: [ 
        '../../../assets/images/patch/technologiesLang/39.png', 
        '../../../assets/images/patch/technologiesLang/40.png',
      '../../../assets/images/patch/technologiesLang/41.png', 
     '../../../assets/images/patch/technologiesLang/42.png',
     '../../../assets/images/patch/technologiesLang/43.png',
     '../../../assets/images/patch/technologiesLang/44.png',
     '../../../assets/images/patch/technologiesLang/45.png'
      ]
    },
    {
      title: 'Data & Analytics',
      subTitle: 'We help enterprises to access & manage data across different sources, seamlessly integrating on-premises and cloud environments to extract actionable insights.',
      offers: [
     'Streams', 'Big Data', 'Analytics', 'Monitoring'
      ],
      images: [
        '../../../assets/images/patch/technologiesLang/46.png',
        '../../../assets/images/patch/technologiesLang/47.png',
        '../../../assets/images/patch/technologiesLang/48.png',
        '../../../assets/images/patch/technologiesLang/49.png',
        '../../../assets/images/patch/technologiesLang/50.png',
        '../../../assets/images/patch/technologiesLang/51.png',
        '../../../assets/images/patch/technologiesLang/52.png',
 
      ]
    },
    {
      title: 'Testing',
      subTitle: 'Zero-bug application is a distant dream but our automation and manual testing experts help you achieve it.',
      offers: [
     'Manual', 'Automation', 'Perfomance'
      ],
      images: [
        '../../../assets/images/patch/technologiesLang/53.png',
        '../../../assets/images/patch/technologiesLang/54.png',
        '../../../assets/images/patch/technologiesLang/55.png', 
        '../../../assets/images/patch/technologiesLang/56.png',
        '../../../assets/images/patch/technologiesLang/57.png',
      ]
    },




  ]

}
